import { useMemo } from 'react';

import { SessionSchema } from '@/types/schema';

export const useChartData = (
  rowData: SessionSchema[],
  accessorFn: (row: SessionSchema) => number | null | undefined
) => {
  const rowDataFiltered = useMemo(() => {
    const filteredData = rowData.filter(
      (row) => accessorFn(row) != null && row.test_run_number != null
    );
    filteredData.sort(
      (a, b) => (a.test_run_number ?? 0) - (b.test_run_number ?? 0)
    );
    return filteredData;
  }, [rowData, accessorFn]);

  return {
    rowData: rowDataFiltered,
  };
};
